import { render } from "./show_description_payment.vue?vue&type=template&id=86a4e4ba"
import script from "./show_description_payment.vue?vue&type=script&lang=js"
export * from "./show_description_payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__